export default __webpack_public_path__ + "static/media/6.f59d6a1b.png";